import { render } from "./ProducerUser.vue?vue&type=template&id=140f54d2"
import script from "./ProducerUser.vue?vue&type=script&lang=js"
export * from "./ProducerUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__